import { Injectable } from '@angular/core'
import { FeathersService } from './feathers.service'
import { readAsDataUrl } from './utils'

export type FileSize = { id: string; size: number }

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  constructor(private feathers: FeathersService) {}

  public static parseFileNameFromUrl(url: string) {
    return url.substring(url.indexOf('-') + 1)
  }

  public async upload(file: File) {
    let fileDataUri = await readAsDataUrl(file)
    return await this.uploadInternal(fileDataUri, file.name)
  }

  // TODO: never got this to work
  public async uploadMultipart(formData: FormData) {
    // return this.feathers.service('file-uploads').create(formData)
  }

  private uploadInternal(fileDataUri, filename): Promise<FileUpload> {
    let fu = new FileUpload()
    fu.uri = fileDataUri
    fu.id = +new Date().getTime() + '-' + filename
    return this.feathers.service('file-uploads').create(fu)
  }

  public async get(fileId) {
    return this.feathers.service('file-uploads').get(fileId)
  }

  public async getSize(fileId): Promise<FileSize> {
    return this.feathers.service('file-uploads').get(fileId, { query: { sizeOnly: true } })
  }

  public async delete(fileId) {
    return this.feathers.service('file-uploads').remove(fileId)
  }
}

export class FileUpload {
  id: string
  uri: string
  size: number
}
